<template>
  <div>
    <h1 class="common__main-title">Export grade evaluation</h1>
    <div class="common__sub-title">export</div>

    <ValidationObserver ref="observer">
      <div class="common__main-contener mb-4">
        <form class="common__main-content">
          <ValidationProvider rules="required" v-slot="{ errors }">
            <div class="form-group">
              <label>Fiscal year</label>
              <select class="form-control w-25" v-model="selectedYear">
                <option v-for="year of years" :key="year" :value="year">{{ year }}</option>
              </select>
              <div class="text-danger">{{ errors[0] }}</div>
            </div>
          </ValidationProvider>
          <ValidationProvider rules="required" v-slot="{ errors }">
            <div class="form-group w-25">
              <label>University</label>
              <UniversityInput v-model="university"/>
              <div class="text-danger">{{ errors[0] }}</div>
            </div>
          </ValidationProvider>
          <div class="form-group w-25">
            <label>Semester</label>
            <SemesterInput v-model="semester"/>
          </div>
          <div class="form-group w-25 mb-5">
            <label>Subject</label>
            <SelectSubjectInput v-model="subject"/>
          </div>
          <div class="d-flex justify-content-center">
            <b-button pill variant="primary" @click="download">
              Export
            </b-button>
          </div>
        </form>
      </div>
    </ValidationObserver>
    <Loading :isLoading="isLoading" />
  </div>
</template>

<script lang="ts">
import _ from 'lodash'
import { Component, Vue } from 'vue-property-decorator'
import moment from 'moment'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import Loading from '@/components/parts/modal/Loading.vue'
import UniversityInput from '@/components/parts/inputItem/SelectUniversityInput.vue'
import SemesterInput from '@/components/parts/inputItem/SemesterInput.vue';
import SelectSubjectInput from '@/components/parts/inputItem/SelectSubjectInput.vue';
// @ts-expect-error 型チェック不要部分
import FileSaver from 'file-saver'
import {
  Semester,
  University,
  Subject,
} from '@/store/master/types'

@Component({
  components: {
    Loading,
    UniversityInput,
    SemesterInput,
    SelectSubjectInput,
    ValidationObserver,
    ValidationProvider,
  },
})

export default class ExportGradeEvaluation extends Vue {
  private selectedYear: number = Number(moment().format('YYYY'))

  private isLoading: boolean = false

  private error: string[]|string|Object|null = null

  private years: number[] = []

  private university: University | null = {
    abbreviation: 'W',
    code: '01',
    name: 'waseda',
  }

  private semester: Semester| null = null

  private subject: Subject | null = null

  created() {
    const start = 2021
    const end = Number(moment().format('YYYY'))
    // 開始年〜終了年
    this.years = _.range(start, end + 1)
  }

  /**
   * 成績評価を出力する
   */
  async download() {
    const isNoProbrem = await (this.$refs.observer as any).validate()
    if (!isNoProbrem) return

    if (this.isLoading) return
    this.isLoading = true

    const condition = {
      year: this.selectedYear,
      university: this.university?.code,
      semester: this.semester?.code,
      subject: this.subject?.code,
    }

    try {
      const { content } = await this.$store.dispatch('exportGradeEvaluationByCsv', condition)
      const blob = new Blob([content], { type: 'text/plain;charset=utf-8' })
      const ym = `${this.selectedYear}`

      FileSaver.saveAs(blob, `grade_evaluation-${moment(ym, 'YYYY').format('YYYY')}.csv`)

      this.isLoading = false
      this.$bvModal.msgBoxOk('Success!')
    } catch (error: any) {
      this.isLoading = false
      const message = _.has(error, 'response') ? error.response.data.message : error.message
      this.$bvModal.msgBoxOk(`Failed. ${message}`)
    }
  }
}
</script>

<style scoped>
.common__main-content {
  min-height: initial;
}
</style>
